const SELECTORS = {
  addToCartBtn: ".btn-secondary",
  closeBtn: ".lightbox-close"
}

export default class Lightbox {
  constructor(selector) {
    this.document = document.body
    this.lightbox = document.querySelector(selector)
    this.closeBtn = this.lightbox.querySelector(SELECTORS.closeBtn)
    this.addToCartBtn = this.lightbox.querySelector(SELECTORS.addToCartBtn)

    this.closeBtn.addEventListener("click", this.close.bind(this))
  }

  open() {
    const documentHeight = this.document.clientHeight

    this.lightbox.style.height = `${documentHeight}px`
    this.lightbox.classList.remove("hide")
    this.lightbox.scrollIntoView(true)
  }

  close(event) {
    if (event) event.preventDefault()

    this.lightbox.classList.add("hide")
  }
}
